<template>
    <app-layout>
        <Head>
            <title>Anfrage einstellen</title>
        </Head>

        <template v-slot:overline>
            <translate>Anfrage einstellen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark" class-names="active">
                    <translate>Bauteilinformationen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting" class-names="active">
                    <translate>Lieferung</translate>
                </step>
                <step icon="credit-card-security-protection" class-names="active">
                    <translate>Anfrage senden</translate>
                </step>
            </stepper>
        </template>

        <div class="ask-for-quote">
            <card class="ask-for-quote--success">
                <card-content>
                    <h5 v-translate>Ihre Anfrage wurde erfolgreich erstellt</h5>
                    <div class="ask-for-quote--icon">
                        <svg-vue icon="checkmark-done-check" class="icon"/>
                    </div>

                    <div>
                        <form-link-button :route="this.$$route('dashboard')" color="primary">
                            <translate>zur Kontoübersicht</translate>
                        </form-link-button>
                    </div>

                </card-content>
            </card>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import Step from '@partfactory/Shared/Stepper/Step';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';

export default {
    name: 'AskForQuote.4',
    components: {
        FormLinkButton,
        Stepper,
        Step,
        CardContent,
        Card,
        AppLayout,
    },
};
</script>
